import React from "react";
import { formatMessage } from "../../../lib/globalize-util";
import { makeStyles } from "@material-ui/core";
import { CUSTOMIZATIONS } from "constants/integration/customizations";

interface IProps {
    label: string;
}

export const CustomizationTitleView: React.FC<IProps> = ({ label, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.customizationTitleContainer} data-test={CUSTOMIZATIONS.PRODUCT_CUSTOMIZATION}>
            <div data-test={CUSTOMIZATIONS.PRODUCT_CUSTOMIZATION_TITLE}>
                <b>{formatMessage("Customization")}:</b>
            </div>
            <div
                data-test={CUSTOMIZATIONS.PRODUCT_CUSTOMIZATION_TITLE_LABEL}
                className={classes.customizationTitleLabel}
            >
                {label}
            </div>
            {children}
        </div>
    );
};

const useStyles = makeStyles({
    customizationTitleContainer: {
        display: "flex",
        alignItems: "center",
        fontSize: "13px",
        paddingBottom: "5px",
    },
    customizationTitleLabel: {
        margin: "0 10px 0 5px",
    },
});
